import { Component, OnInit, ChangeDetectionStrategy, Input, HostListener } from '@angular/core';
import { ModalOptions } from '../modal/modal.component';
import { ModalService } from '../form-core/modal/modal.service';

@Component({
  selector: 'div[data-component-type=modal-opener]',
  templateUrl: './modal-opener.component.html',
  styleUrls: ['./modal-opener.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalOpenerComponent implements OnInit {

  @Input() label!: 'button' | 'ikon'
  @Input() text!: string
  @Input() modalOptions!: ModalOptions
  @Input() alwaysInfoIcon: boolean = false

  constructor(private modal: ModalService) {
  }

  ngOnInit(): void {
  }

  @HostListener('click') openModal() {
    this.modal.create(this.modalOptions)
  }

}

export interface ModalOpenerOptions {
  label: 'button' | 'ikon',
  text?: string,
  modal: ModalOptions,
  alwaysInfoIcon?: boolean
}
